<template>
  <b-card no-body>
    <b-row class="my-3 mx-2">
      <b-col>
        <strong v-if="!!memberships">
          {{ memberships.length }}
          {{ trans('membership' + (memberships.length > 1 || memberships.length == 0 && lang == 'en' ? 's' : '')).toLowerCase() }}
        </strong>
        <small class="d-block">
          {{ trans('questions') }}?
          <b-link v-if="!!organization.email" :href="`mailto:${organization.email}`">
            {{ organization.email }}
          </b-link>
          <b-link v-if="!!organization.phone" :href="`tel:${organization.phone}`">
            {{ organization.phone }}
          </b-link>
        </small>
      </b-col>
      <b-col class="col-auto">
        <b-button v-if="organization.has_stripe" variant="outline-primary" size="sm" class="mr-2" :disabled="busy" v-b-modal.client-credit-card-on-file-modal>
          <i class="fa fa-fw fa-credit-card"></i>
          {{ trans('cc_on_file') }}
        </b-button>
      </b-col>
    </b-row>

    <b-table
      id="memberships"
      ref="table"
      class="bg-white"
      responsive
      show-empty
      :per-page="perPage"
      :current-page="currentPage"
      :fields="fields"
      :items="memberships"
    >
      <template #empty>
        <p align="center">
          <span v-if="!busy">{{ trans('none') }}</span>
          <span v-if="busy">
            <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
            {{ trans('please_wait') }}
          </span>
        </p>
      </template>
      <template #cell(membership_name)="data">
        <b-button
          variant="link"
          class="text-branded"
          v-if="data.item.membership_has_card"
          @click="onClickShowMembershipCard(data.item)"
        >
          <i class="fa fa-fw fa-id-card"></i>
        </b-button>
        {{ data.value }}
      </template>
      <template #cell(created_at)="data">
        <small>{{ data.value }}</small>
      </template>
    </b-table>
    <b-pagination
      :total-rows="totalRows"
      :per-page="perPage"
      v-model="currentPage"
      aria-controls="memberships"
      align="center"
    ></b-pagination>
    <client-credit-card-on-file-modal
      :organization="organization"
      :client="client"
    ></client-credit-card-on-file-modal>
    <b-modal
      id="membership-card-modal"
      hide-footer
      hide-header
    >
      <membership-card
        v-if="!!membership"
        :organization="organization"
        :membership-card="membership"
      ></membership-card>
    </b-modal>
  </b-card>
</template>

<script>
  import ClientCreditCardOnFileModal from './ClientCreditCardOnFileModal'
  import MembershipCard from './../membership/MembershipCard'

  export default {
    props: {
      organization: Object,
      client: Object,
    },
    components: {
      ClientCreditCardOnFileModal,
      MembershipCard,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        invoice: null,
        memberships: null,
        membership: null,
        recipientId: null,
        perPage: 10,
        currentPage: 1,
        totalRows: 0,
        lang: window.lang,
      }
    },
    computed: {
      fields() {
        return _.compact([
          {
            key: 'membership_name',
            label: trans('membership'),
          },
          {
            key: 'active_at',
            label: trans('active_at'),
            formatter(value, key, item) {
              return value ? moment(value).fromNow() : null
            },
          },
          {
            key: 'expired_at',
            label: trans('expired_at'),
            formatter(value, key, item) {
              return value ? moment(value).fromNow() : null
            },
          },
          {
            key: 'membership_name',
            label: trans('name'),
          },
        ])
      },
    },
    methods: {
      onClickShowMembershipCard(membership) {
        this.membership = membership
        this.$bvModal.show('membership-card-modal')
      },
      fetch() {
        this.busy = true
        this.error = null
        let query = `?page=${this.currentPage}&per_page=${this.perPage}`
        let url = `/org/${this.organization.id}/client/memberships${query}`
        return axios.get(url)
        .then(response => {
          this.busy = false

          this.memberships = response.data
          this.totalRows = this.memberships.length
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          this.memberships = []
        })
      },
    },
    mounted() {
      window.myMemberships = this
      this.fetch()
    },
  }
</script>
